import { useEffect, useState } from 'react'
import CustomSwitch from '../../common/form/CustomSwitch'
import FormDrawer from '../../common/form-drawer'
import { toast } from 'react-toastify';
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { saveEditedDeduction, toggleEditDeductionModal } from 'store/entities/payroll/payrollSetup/action';

const defaultForm = {id: Math.random(), is_shown_on_payslip: false, is_remitted_to_government: false}

const EditDeductionModal = () => {
	const {dispatch, useSelector, lettersRegex} = usePayrollEssentials()
	const [form, setForm] = useState(defaultForm);

	const {isEditDeductionOpen, selectedDeduction: selected} = useSelector(state => state.entities.payrollSetup)

const toggleModal = () => dispatch(toggleEditDeductionModal())
const deductPercent = form?.type?.toLowerCase() === 'percentage'

const onSubmit = (e) => {
    e.preventDefault()
		const value = form.value

		if(!lettersRegex.test(form?.name)) {
			toast.error("Deduction name must contain letters")
		} else if((deductPercent && value > 100) || (deductPercent && value < 1)) {
			toast.error('Deduction value must be between 1 - 100')
		} else if(!deductPercent && value < 1) {
			toast.error('Deduction value must be at least ₦1')
		} else {
			const payload = {
				...form,
				id: selected.id,
				value: Number(value)
			}
			dispatch(saveEditedDeduction(payload))
			e.target.reset()
			toggleModal()
			}
}

const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    setForm({...form, [name]: value})
}

useEffect(() => {
		setForm(selected)
}, [selected])

    return (
		<FormDrawer display="center" size="md" isOpen={isEditDeductionOpen} setIsOpen={toggleModal}>
			<form onSubmit={onSubmit}>
				<div className="p-7">
						<div className="mb-5">
								<p className="mb-1 font-semibold lg:text-lg capitalize">Edit {selected?.name}</p>
						</div>
						<div className="mb-5">
								<p className="text-sm mb-2">Name of Deduction</p>
								<input minLength={3} maxLength={30} type="text" value={form?.name || ""} onChange={handleChange} name='name' className="form-input" />
						</div>

						<div className="mb-5">
								<p className="text-sm mb-1">Description</p>
								<input type="text" value={form?.description || ""} name='description' onChange={handleChange} className="form-input" />
						</div>

						<div className="mb-5">
							<p className="text-sm mb-1">Where should it be deducted from? (source)</p>
							<select value={form?.source || ""} name="source" onChange={handleChange} className="form-input">
									<option value="">Select source</option>
									<option value="BASIC">Basic</option>
									<option value="HOUSING">Housing</option>
									<option value="TRANSPORT">Transport</option>
									<option value="BASIC_AND_HOUSING">Basic and Housing</option>
									<option value="BASIC_AND_TRANSPORT">Basic and Transport</option>
									<option value="HOUSING_AND_TRANSPORT">Housing and Transport</option>
									<option value="BASIC_HOUSING_AND_TRANSPORT">Basic, Housing, and Transport</option>
									<option value="GROSS_SALARY">Gross Salary</option>
							</select>
						</div>

						<div className="mb-5">
							<p className="text-sm mb-1">Deduction type</p>
							<select value={form?.type || ""} name="type" onChange={handleChange} className="form-input">
									<option value="">Select type</option>
									<option value="PERCENTAGE">Percentage</option>
									<option value="FIXED_AMOUNT">Fixed Amount (₦)</option>
							</select>
						</div>

						<div className="mb-5">
							<p className="text-sm mb-1">Deduction value</p>
							<div className="flex-btw">
							<input type="number" id='prl-input' value={form?.value || ""} name='value'
							onChange={handleChange} className="form-input mr-2" />
							<div style={{width: '50px', height: '40px'}} className="flex items-center justify-center bg-gray-200 rounded-md">
								<div>{deductPercent ? '%' : '₦'}</div>
							</div>
							</div>
						</div>

						<div className="mb-5 border flex-btw p-2 items-center">
							<p className="mb-0 text-ep-primary-600 text-sm">Show on the payslip?</p>
							<div>
								<CustomSwitch active={form?.is_shown_on_payslip || false} activeText="Yes"
								inactiveText="No" onChange={() => setForm({...form, is_shown_on_payslip: !form.is_shown_on_payslip})} />
							</div>
						</div>

						<div className="mb-5 border flex-btw p-2 items-center">
							<p className="mb-0 text-ep-primary-600 text-sm">Do you remit this deduction?</p>
							<div>
								<CustomSwitch active={form?.is_remitted_to_government || false} activeText="Yes"
								inactiveText="No" onChange={() => setForm({...form, is_remitted_to_government: !form.is_remitted_to_government})} />
							</div>
						</div>
				</div>

				<div className="w-full flex items-center mb-4 pl-7">
					<button onClick={toggleModal} type='button' className="btn btn-md btn-transparent-primary mr-4 lg:mr-6">Cancel</button>
					<button type="submit" className="btn btn-md btn-ep-primary">Save Edits</button>
				</div>
			</form>
		</FormDrawer>
		)
}

export default EditDeductionModal